import './SearchField.css'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'

type Props = {
  searchValue?: string
  setSearchValue:
    | React.Dispatch<React.SetStateAction<string>>
    | ((value: string) => void)
  placeholder?: string
  className?: string
  classNameInput?: string
  width?: number
}

export const SearchField: React.FC<Props> = ({
  searchValue,
  setSearchValue,
  placeholder,
  className,
  classNameInput,
  width = 18,
}) => {
  const { t } = useTranslation()

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchValue(value)
  }

  const handleDeleteClick = () => {
    setSearchValue('')
  }

  const showDeleteIcon =
    searchValue !== undefined && searchValue !== null && searchValue !== ''

  return (
    <IconField
      iconPosition="left"
      className={`search-field ${className}`}
      style={{ width: width + 'rem' }}
    >
      {/* Search Icon */}
      <InputIcon className="search-field__search-icon pi pi-search"></InputIcon>

      {/* Input */}
      <InputText
        id="globalSearchField"
        value={searchValue}
        onChange={handleInputChange}
        className={`search-field__input ${classNameInput}`}
        placeholder={placeholder || t('common.placeholders.search')}
      />

      {/* Delete icon */}
      {showDeleteIcon && (
        <InputIcon
          className="search-field__delete-icon pi pi-times"
          aria-label="Delete search word"
          onClick={handleDeleteClick}
        ></InputIcon>
      )}
    </IconField>
  )
}
